<template>
  <VDateInput
    v-model="request.desiredReceiptDate"
    label="Дата доставки"
    layout="vertical"
    :disabled="request.demand.isOptionsSelected"
  />

  <VFormItem class="qty">
    <VInputNumberRusV2
      v-model="request.qtyDesired"
      label="Количество"
      layout="vertical"
      :type="Qty"
      :max="1000000"
      :disabled="request.demand.isOptionsSelected"
    />

    <VSelectV2
      v-model="request.demand.unit"
      class="unit"
      label="Ед. изм"
      layout="vertical"
      disabled
      :data="$core.dictionaries.units"
    />
  </VFormItem>
</template>

<style src="./DemandRequestCreateForm.scss" lang="scss" />

<script lang="ts">

import DemandRequest from '@/domains/DemandsV2/DemandRequest';
import Qty           from '@/core/types/Qty';

export default defineComponent({
  name: 'DemandRequestCreateForm',

  props: {
    request: {
      type:    DemandRequest,
      default: null,
    },
  },

  setup() {
    return {
      Qty,
    };
  },
});
</script>
